import Account from "../../services/account"
import * as types from "../mutationTypes";

let state = {
    adminError: null,
    adminSuccess: null,
    forgotPasswordError: null,
    forgotPasswordSuccess: null,
    resetPasswordError: null,
    resetPasswordSuccess: null,

    error: null,
    success: null,
}
let getters = {
    forgotPasswordError (state) {
        return state.forgotPasswordError
    },
    forgotPasswordSuccess (state) {
        return state.forgotPasswordSuccess
    },
    resetPasswordError (state){
        return state.resetPasswordError
    },
    resetPasswordSuccess(state){
        return state.resetPasswordSuccess
    },
    adminSuccess (state)
    {
        return state.adminSuccess
    },
    adminError (state)
    {
        return state.adminError
    }
}
const mutations = {
    [types.REQUEST_CLEAR_ACCOUNT_ERROR] (state, message) {
        state.error = message;
        state.success = null;
    },
    [types.REQUEST_SEND_FORGOT_PASSWORD_EMAIL_ERROR] (state, message) {
        state.forgotPasswordError = message;
        state.forgotPasswordSuccess = null;
    },
    [types.REQUEST_SEND_FORGOT_PASSWORD_EMAIL_SUCCESS] (state, message) {
        state.forgotPasswordError = null;
        state.forgotPasswordSuccess = message;
    },
    [types.REQUEST_RESET_PASSWORD_ADMIN_SUCCESS] (state, message) {
        state.adminError = null;
        state.adminSuccess = message;
    },
    [types.REQUEST_RESET_PASSWORD_ADMIN_ERROR] (state, message) {
        state.adminError = message;
        state.adminSuccess = null;
    },
    [types.REQUEST_SUBMIT_PASSWORD_SUCCESS] (state, message) {
        state.resetPasswordError = null;
        state.resetPasswordSuccess = message;
    },
    [types.REQUEST_SUBMIT_PASSWORD_ERROR] (state, message) {
        state.resetPasswordError = message;
        state.resetPasswordSuccess = null;
    },
    [types.RESET_SUBMIT_SUCCESS_MESSAGE] (state) {
        state.resetPasswordSuccess = null;
    },

}
const actions = {

    async clearAccount () {
    },
    async clearSubmitSuccessMessage({ commit }){
        commit(types.RESET_SUBMIT_SUCCESS_MESSAGE)
    },
    async sendForgotPassword ({ commit, dispatch }, email) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            if (email != null) {
                let res = await Account.sendForgotPassword(email)
                if (res.status === 200) {
                    commit(types.REQUEST_SEND_FORGOT_PASSWORD_EMAIL_SUCCESS, res.data)
                }
            } else {
                commit(types.REQUEST_SEND_FORGOT_PASSWORD_EMAIL_ERROR, 'Please enter an email')
            }
        } catch (err) {
            commit(types.REQUEST_SEND_FORGOT_PASSWORD_EMAIL_ERROR, `Error sending email: ${err.message}`)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },
    async resetPasswordAdmin ({ commit, dispatch }, data) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            if (data.password === data.confirm) {
                let passwordForm = { password: data.password, email: data.email, token: null }
                let res = await Account.resetPasswordAdmin(passwordForm)
                if (res.status === 200) {
                    commit(types.REQUEST_RESET_PASSWORD_ADMIN_SUCCESS, res.data)
                }
            } else {
                commit(types.REQUEST_RESET_PASSWORD_ADMIN_ERROR, "Passwords Don't Match")
            }
        } catch (err) {
            commit(types.REQUEST_RESET_PASSWORD_ADMIN_ERROR, err.message)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },
    async submitPassword ({ commit, dispatch }, data) {
        dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
        try {
            if (data.password === data.confirm) {
                let passwordForm = { password: data.password, email: data.email, token: data.token }
                let res = await Account.resetPassword(passwordForm)
                if (res.status === 200) {
                    commit(types.REQUEST_SUBMIT_PASSWORD_SUCCESS, res.data)
                }
            } else {
                commit(types.REQUEST_SUBMIT_PASSWORD_ERROR, "Passwords Don't Match")
            }
        } catch (err) {
            commit(types.REQUEST_SUBMIT_PASSWORD_ERROR, err.message)
        }
        dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
